"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Spacer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%'
    },
    Left: {
      display: 'flex',
      flexGrow: 0,
      flexShrink: 1,
      minWidth: 0,
      '& > li': {
        background: theme['$button-color']
      },
      '& > *': {
        flexGrow: 1,
        flexShrink: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'block',
        width: '100%',
        lineHeight: 1.17
      }
    },
    Right: {
      flexGrow: 0,
      flexShrink: 0
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map